var customMarkerIcon, map, markerCoordinates;

markerCoordinates = [
  {
    title: "Zucker & Zimt Burgcafé",
    latitude: 50.965997657286366,
    longitude: 10.306087083806702
  },
  {
    title: "Zucker & Zimt am Kräutergarten",
    latitude: 50.965823673540754,
    longitude: 10.306065826134185
  },
  {
    title: "Zucker & Zimt Café-Restaurant",
    latitude: 50.97481546046235,
    longitude: 10.320384166608061
  },
  {
    title: "Zucker & Zimt Konditorei und Tortenwerkstatt",
    latitude: 50.976154568939755,
    longitude: 10.327730983807362
  },
  {
    title: "Zucker & Zimt Eis- und Schokoladenmanufaktur",
    latitude: 50.97446991664524,
    longitude: 10.320404510789531
  },
  {
    title: "Zucker & Zimt Kombüse",
    latitude: 50.9746712941549,
    longitude: 10.320456754970971
  }
];

customMarkerIcon = L.icon({
  iconUrl: 'assets/img/bxs_castle.svg',
  iconSize: [32, 32],
  iconAnchor: [6, 76],
  popupAnchor: [-3, -76],
  shadowUrl: 'assets/img/bxs_marker_shadow.svg',
  shadowSize: [64, 64],
  shadowAnchor: [22, 94]
});

map = L.map('map').setView([50.9714213, 10.3140303], 14);

L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  maxZoom: 19,
  attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
}).addTo(map);

markerCoordinates.forEach(function(markerCoords) {
  return L.marker([markerCoords.latitude, markerCoords.longitude], {
    icon: customMarkerIcon
  }).addTo(map).bindTooltip(markerCoords.title);
});
